import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { LinkAdvisorsTemplate as template } from './link-advisors.template';
import { LinkAdvisorsStyles as styles } from './link-advisors.styles';
import { Dialog, TextField } from '@microsoft/fast-foundation';
import { ICompanyService } from '../../../../services/company.service';
import { IUserService } from '../../../../services/user.service';
import { notify, notifyError } from '../../../../utils/notify';

export interface BuyerAdvisorCompany {
  COMPANY_NAME: string;
  COMPANY_ID: string;
  USER_LIST: BuyerAdvisorUserList[];
}

export interface BuyerAdvisorUserList {
  USERNAME: string;
  COMPANY_NAME: string;
}

export enum AdvisorCompanyGrid {
  BUYER = 'BUYER',
  ADVISOR = 'ADVISOR',
  USER = 'USER',
}

export interface AdvisorUserByCompany {
  ASSIGNED: boolean;
  ASSIGNED_COMPANIES: string;
  NAME?: string;
  USERNAME: string;
  ROLES: string;
}

@customElement({
  name: 'link-advisors',
  template: template,
  styles: styles,
})
export class LinkAdvisorsCompany extends FASTElement {
  @ICompanyService companyService: ICompanyService;

  @observable buyerCompanyData: BuyerAdvisorCompany[];
  @observable advisorCompanyData: any[];
  @observable advisorUsersData: AdvisorUserByCompany[];

  @observable filteredBuyerCompanyData: BuyerAdvisorCompany[];
  @observable filteredAdvisorCompanyData: any[];
  @observable filteredAdvisorUsersData: AdvisorUserByCompany[];

  @observable currentBuyerCompany: string = '';
  @observable currentAdvisorCompany: string = '';

  @observable currentIcon: string;
  @observable tooltipVisable: boolean = true;

  buyerCompanySearch: TextField;
  advisorCompanySearch: TextField;
  advisorUserCompanySearch: TextField;

  public linkAdvisorsModal: Dialog;

  connectedCallback() {
    super.connectedCallback();
    this.getBuyerCompanyData();
    this.getAdvisorCompanyData();
  }

  getBuyerCompanyData() {
    this.companyService.getBuyerAdvisorCompany().then((data) => {
      this.buyerCompanyData = data.REPLY;
      this.handleSearch(AdvisorCompanyGrid.BUYER);
    });
  }

  getAdvisorCompanyData() {
    this.companyService
      .getAllCompaniesShanpshot(
        `COMPANY_ROLE == 'ADVISOR' && ((SEF_PARTICIPANT_AGREEMENT_CONSENT == true && SEF_PARTICIPANT_AGREEMENT_CONSENT_DATETIME != null) || NON_SEF_PARTICIPANT_AGREEMENT_CONSENT_DATE != null)`
      )
      .then((data) => {
        this.advisorCompanyData = data.ROW;
        this.handleSearch(AdvisorCompanyGrid.ADVISOR);
      });
  }

  handleCompanyRadioSelect(value, grid: AdvisorCompanyGrid) {
    if (grid == AdvisorCompanyGrid.BUYER && this.currentAdvisorCompany != '') {
      return;
    }
    var oldValue =
      grid === AdvisorCompanyGrid.ADVISOR ? this.currentAdvisorCompany : this.currentBuyerCompany;
    var newValue = value === oldValue ? '' : value;
    switch (grid) {
      case AdvisorCompanyGrid.ADVISOR:
        this.currentAdvisorCompany = newValue;
        break;
      case AdvisorCompanyGrid.BUYER:
        this.currentBuyerCompany = newValue;
        break;
      default:
        break;
    }

    if (this.currentBuyerCompany && this.currentAdvisorCompany) {
      this.companyService
        .getAdvisorUsersByCompany(this.currentBuyerCompany, this.currentAdvisorCompany)
        .then((data) => {
          this.advisorUsersData = data.REPLY;
          this.advisorUsersData.sort((x, y) => {
            if (x.ASSIGNED_COMPANIES === 'Unassigned' && y.ASSIGNED_COMPANIES != 'Unassigned') {
              return 1;
            } else if (
              y.ASSIGNED_COMPANIES === 'Unassigned' &&
              x.ASSIGNED_COMPANIES != 'Unassigned'
            ) {
              return -1;
            } else {
              return 0;
            }
          });
          this.handleSearch(AdvisorCompanyGrid.USER);
        });
    } else {
      this.advisorUsersData = [];
      this.filteredAdvisorUsersData = [];
    }
  }

  handleSearch(grid: AdvisorCompanyGrid) {
    switch (grid) {
      case AdvisorCompanyGrid.ADVISOR:
        var value = this.advisorCompanySearch.value.toLowerCase();
        if (value === null || value === '') {
          this.filteredAdvisorCompanyData = this.advisorCompanyData;
        } else {
          this.filteredAdvisorCompanyData = this.advisorCompanyData.filter((data) =>
            (data.NAME as string).toLowerCase().includes(value)
          );
        }
        break;
      case AdvisorCompanyGrid.BUYER:
        var value = this.buyerCompanySearch.value.toLowerCase();
        if (value === null || value === '') {
          this.filteredBuyerCompanyData = this.buyerCompanyData;
        } else {
          this.filteredBuyerCompanyData = this.buyerCompanyData.filter((data) =>
            data.COMPANY_NAME.toLowerCase().includes(value)
          );
        }
        break;
      case AdvisorCompanyGrid.USER:
        var value = this.advisorUserCompanySearch.value.toLowerCase();
        if (value === null || value === '') {
          this.filteredAdvisorUsersData = this.advisorUsersData;
        } else {
          this.filteredAdvisorUsersData = this.advisorUsersData?.filter((data) =>
            (data.NAME ? data.NAME : data.USERNAME).toLowerCase()?.includes(value)
          );
        }
        break;
      default:
        break;
    }
  }

  updateAssignments() {
    this.companyService
      .eventAdvisorUserCompanyUpdate({
        BUYER_COMPANY_ID: this.currentBuyerCompany,
        USERS: this.advisorUsersData.map((user) => ({
          USER_NAME: user.USERNAME,
          ASSIGNED: user.ASSIGNED,
        })),
      })
      .then((response) => {
        if (response.MESSAGE_TYPE === 'EVENT_ACK') {
          notify('Changes saved');
          this.close();
        } else {
          notifyError(response.ERROR[0]?.TEXT);
        }
      });
  }

  close() {
    this.buyerCompanyData = [];
    this.currentBuyerCompany = '';
    this.advisorCompanyData = [];
    this.currentAdvisorCompany = '';
    this.advisorUsersData = [];
    this.filteredAdvisorCompanyData = [];
    this.filteredAdvisorUsersData = [];
    this.filteredBuyerCompanyData = [];
    this.$emit('close');
  }
}
